module.exports = "<!-- <app-nav-bar></app-nav-bar> -->\n<app-home-banner></app-home-banner>\n<app-about></app-about>\n<app-portfolio></app-portfolio>\n<app-skills></app-skills>\n<app-resume></app-resume>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main